// removed by extract-text-webpack-plugin
module.exports = {"overlay":"DeepLinkModal__overlay___16NtD","modal":"DeepLinkModal__modal___2johF","container":"DeepLinkModal__container___1hIjl","content":"DeepLinkModal__content___27mp6"};